<div class="checkbox-with-badge-wrapper">
    <mat-checkbox
        [name]="name"
        [id]="id"
        [(ngModel)]="model"
        [indeterminate]="indeterminate"
        [disabled]="disabled"
        (change)="modelChanged(model)"
        [ngClass]="tailwindClasses">
        <span class="checkboxLabel textEllipsis {{ labelTextClass }}" [textContent]="displayName"></span>
        <material-button
            *ngIf="description?.length > 0"
            matPrefix
            buttonType="icon"
            size="small"
            color="default"
            [titleText]="description"
            tabindex="-1"
            prefixIcon="info"
            prefixIconType="material"></material-button>
    </mat-checkbox>
    <span *ngIf="badge && badge > 0" class="custom-badge">{{ badge }}</span>
</div>
